export default {
    web_primary_color: '#0445cf',
    red: '#FF0000',
    blue: '#1D9CFD',
    orange: 'ffA500',
    yellow: '#ffb54a',
    green: '#159f46'
};
